// extracted by mini-css-extract-plugin
module.exports = {"courseware_canvas_layer":"index_courseware_canvas_layer_3wG_z"};